import { useMutation } from '@apollo/client/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_OPEN_BILLING_PORTAL } from '~/gql/billing/billing'
import { useResetOnPageShow } from '~/hooks/use-reset-on-page-show'
import { checkoutErrorKey } from '~/pages/backoffice/admin/billing/checkout-error'
import { goToStripe } from '~/pages/backoffice/admin/billing/stripe-redirect'

/** Ouvre le portail client Stripe (#353) ; ce qui y change revient par le webhook. */
export function useOpenBillingPortal() {
  const { t } = useTranslation()
  const [opening, setOpening] = useState(false)
  const [openBillingPortal] = useMutation(GQL_OPEN_BILLING_PORTAL)
  // Retour arrière depuis Stripe : le bouton ne reste pas « en cours ».
  useResetOnPageShow(() => setOpening(false))

  const open = async () => {
    setOpening(true)
    try {
      const { data } = await openBillingPortal()
      goToStripe(data?.openBillingPortal)
    } catch (error) {
      setOpening(false)
      toast.error(t(checkoutErrorKey(error)))
    }
  }

  return { open, opening }
}
